export const RatingStars = {
  bindings: {
    size: '@',
    rating: '<',
    isEnabled: '<',
    onClick: '&',
  },

  template: `
    <div class="rating-stars"
      ng-class="{ 'rating-stars--hover': $ctrl.isEnabled }">
      <i class="fa fa-star"
        ng-repeat="i in [5,4,3,2,1] track by $index"
        ng-click="$ctrl.onClick({ value: i })"
        ng-class="{
          'fa-lg': $ctrl.size === 'md',
          'fa-3x': $ctrl.size === 'lg',
          'active': i <= $ctrl.rating,
        }">
      </i>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/RatingStars/RatingStars.js